import { STATUS_COLORS, STATUS_LABELS } from '../utils/constants';

interface BadgeProps { status: string; small?: boolean; label?: string; }

export default function Badge({ status, small, label: labelOverride }: BadgeProps) {
  const m     = STATUS_COLORS[status] ?? { color: '#5F5E5A', bg: '#F1EFE8' };
  const label = labelOverride ?? (STATUS_LABELS[status] ?? status);
  return (
    <span
      className={`font-medium rounded-full whitespace-nowrap ${small ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-0.5'}`}
      style={{ background: m.bg, color: m.color }}
    >
      {label}
    </span>
  );
}
